import { render } from "./AddViewNote.vue?vue&type=template&id=d9105fac&scoped=true&ts=true"
import script from "./AddViewNote.vue?vue&type=script&lang=ts"
export * from "./AddViewNote.vue?vue&type=script&lang=ts"

import "./AddViewNote.vue?vue&type=style&index=0&id=d9105fac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9105fac"]])

export default __exports__